module.exports = __webpack_public_path__ + "img/logos.4dfaa174.png";